<template>
  <div>
    <el-dialog :title="titleName" @close="closeDialog" :visible.sync="dialogVisable" :modal-append-to-body="false" width="850px" height="504px"
      style="margin-top:4vh;" class="add-label-dialog" :close-on-click-modal="false">
      <div>
        <div class="row">
          <span class="required">*</span>
          <span class="label">{{myType==5?'消息名称':'SOP名称'}}</span>
          <div>
            {{ myType==5?detaildata.msgName:detaildata.sopName }}
          </div>
        </div>
        <div class="row">
          <span class="required">*</span>
          <span class="label" >选择员工</span>
          <div>
            已选择
            {{ myType==5?detaildata.userVoList?detaildata.userVoList.length:'':detaildata.userListSize }}
            位
          </div>
        </div>
        <div class="select-wrap" v-if="myType!=5 && detaildata.userList && detaildata.userList.length != 0">
          <el-tag  v-for="(item,index) in detaildata.userList" :key="index" size="small" >
            {{item.userName}}
          </el-tag>
        </div>
        <div class="select-wrap" v-if="myType==5 && detaildata.userVoList && detaildata.userVoList.length != 0">
          <el-tag  v-for="(item,index) in detaildata.userVoList" :key="index" size="small" >
            {{item.userName}}
          </el-tag>
        </div>
        <div class="row" v-if="myType == 5 && detaildata.cusTotal && detaildata.cusTotal != null">
          <span class="required" style="color: white;">*</span>
          <span class="label" >服务客户</span>
          <div>
            <div class="after-select">
              <div>预计触达{{detaildata.cusTotal}}位客户</div>
            </div>
          </div>
        </div>
        <div class="row">
          <span class="required">*</span>
          <span class="label" >{{ myType==5?'发送内容':'任务详情'}}</span>
        </div>
        <div class="task-detail"> 
          <slot name="taskDetail" >
            <template v-if="myType == 1">
              <div class="detial-item" >
                通过好友
                <el-input
                  class="number-input"
                  type="number"
                  v-model="hours"
                  size="small"
                  readonly
                  :min="0"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width:80px;"
                >
                </el-input>
                小时
                <el-input
                  class="number-input"
                  type="number"
                  v-model="minute"
                  size="small"
                  readonly
                  :min="0"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width:80px;"
                >
                </el-input>
                分钟 后发送
              </div>
            </template>
            <template v-if="myType == 2">
              <div class="detial-item">
                <!-- 生日当天 -->
                <span> 发送时间：客户生日前 <el-input v-model="daysAgo" size="small" style="width: 60px; margin: 0 5px;" readonly/>天</span>
                <el-time-picker
                  v-model="value1"
                  format = 'HH:mm' 
                  value-format = 'HH:mm'
                  readonly
                  size="small"
                  :clearable="false"
                  style="width:100px;margin:0 12px"
                  placeholder="任意时间点">
                </el-time-picker>
                发送
                <el-tooltip class="item" effect="dark" content="将于客户公历生日当天发送祝福" placement="top-start">
                  <i class="el-icon-question icon-style"></i>
                </el-tooltip>
              </div>
            </template>
            <template v-if="myType == 3">
              <div class="detial-item">
                <span class="label" >起止时间</span>
                <div>
                  <el-date-picker
                    v-model="searchSelectTime"
                    size="mini"
                    readonly
                    type="datetimerange"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    range-separator="~"
                    :clearable="false"
                    style="width: 240px; margin-right: 10px"
                  >
                  </el-date-picker>
                </div>
              </div>
            </template>
          </slot>
          <MyUploadDetail :myType="myType" :upLoadData="upLoadData" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small"  @click="confirmWeicome()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import MyUploadDetail from '@/views/mass/SOP/components/myupLoadDetail.vue'

export default {
  // sop任务详情弹框
  name: "SOPDetail",
  components: {
    MyUploadDetail
  },
  props: {
    detaildata: {
      type: Object,
      default: ()=>({
        sopName: "",
        userList: [],
        afterAdd: 0,   //添加多少分钟后发送
        content: "",  //内容
        resourceVos: [],
        sopLink: {},
        userListSize: 0
      })
    },
    titleName: {
      type: String,
      default: '新增好友SOP'
    },
    myVisiable: {
      type: Boolean,
      default: false
    },
    // 类型 1为好友sop详情，2为生日提醒sop详情，3为朋友圈sop详情
    myType: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      sopName: '',
      userList: [],
      // 新增好友参数
      params1: {
        sopName: '',
        userList: [],       // 员工列表
        afterAdd: 0,
        content: '',
        resourceVos: [],
        linkVo: {
          title: '',
          httpUrl: '',
          content: '',
          pictureUrl: '',
          pictureName: ''
        }
      },
      value1: '',
      hours: 0,             // 新增好友sop所需参数
      minute: 0,            // 新增好友sop所需参数
      daysAgo: 0,

      dialogVisibleTree: false,       // 选择成员树
      searchSelectTime: [],           // 存放选择时间的数据
      dialogVisable: false,
      upLoadData: {}
    };
  },
  created() {
  },
  watch: {
    myVisiable(val) {
      this.dialogVisable = val
    },
    detaildata: {
      handler(newVal,oldVal) {
        console.log('newVal',JSON.parse(JSON.stringify(newVal)))
        console.log('this.myType',this.myType)
        if(this.myType == 3) {
          this.searchSelectTime = [newVal.startTimeFriSop,newVal.endTimeFriSop]
          console.log('this.searchSelectTime',this.searchSelectTime)
        }
        if(this.myType == 2) {
          this.value1 = newVal.sendTime
          this.daysAgo = newVal?.daysAgo ?? 0
          console.log(newVal)
        }
        if(this.myType == 1) {
          this.hours = Math.floor(parseFloat(newVal.afterAdd/60))
          this.minute = parseInt(newVal.afterAdd%60)
        }
        let obj = {
          content: newVal.content,
          resourceVos: newVal.resourceVos,
          sopLink: newVal.sopLink
        }
        this.upLoadData = JSON.parse(JSON.stringify(obj))
        console.log('this.upLoadData',this.upLoadData)
      },
      deep:true
      
    }
  },
  computed: {
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog", false);
    },
    // 确定按钮
    confirmWeicome() {
      this.$emit("closeDialog", false);
    },
  },
  
  
};
</script>
<style lang="scss" scoped>
 /deep/ .el-dialog {
  // min-height: 504px;
}
/deep/.el-dialog__header {
  padding: 28px 32px 20px;
  .el-dialog__title {
    font-size: 16px;
    font-weight: bold;
  }
}
/deep/ .el-dialog__body {
  padding: 0px 24px 20px 32px;
}
/deep/ .el-dialog__footer{
  text-align: right;
  padding: 0 26px 20px;
}
.row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .required {
    color: #FF4B59;
    margin-right: 5px;
    transform: translate(0, 2px);
  }
  .label {
    margin-right: 15px;
    font-size: 14px;
    font-weight: bold;
  }
  .after-select {
    color: #333333;
    display: flex;
    align-items: center;
  }
  /deep/.my-select {
    cursor: pointer;
    .el-input__inner {
      cursor: pointer;
    }
  }
}
.select-wrap {
  margin-left: 80px;
  max-height: 200px;
  overflow: scroll;
  /deep/ .el-tag{
    margin: 4px 4px;
  }
}
.task-detail {
  padding: 0 11px;
  font-size: 12px;
  .detial-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .label {
      margin-right: 15px;
      font-size: 14px;
      font-weight: bold;
    }
    .icon-style {
      margin-left: 12px;
    }
  }
  /deep/.number-input {
    margin: 0 4px;
    .el-input__inner {
      padding: 0 4px 0 15px;
    }
  }
  
}
</style>